<template>
  <div>
    <template v-if="$options.components['advertisement-loading']">
      <advertisement-loading v-if="isLoading" />
    </template>
    <div
      v-if="productList.length == 0 && !isLoading"
      class="text-center no-item"
    >
      {{ $t("productStore.noItmes") }}
    </div>
    <sections-slider
      v-if="productList && productList.length"
      :list="productList"
      :subTitle="$route.params.market"
      :showTitle="true"
      :hasBackground="false"
      :hasButton="false"
      :withoutSlider="true"
    >
      <template slot="default" slot-scope="{ listItem }">
        <div class="item-box">
          <items-item
            :itemNoBg="true"
            :product="listItem"
            :incrementDecrementKey="true"
            class="suggester-div w-100"
          ></items-item>
        </div>
      </template>
    </sections-slider>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      productList: (state) => state.healthCare.healthCareProductsList,
    }),
  },

  methods: {},

  async mounted() {
    this.isLoading = true;
    let payload = {
      categoryId: this.$route.params.id,
      offset: 0,
    };
    await this.$store.dispatch(
      "healthCare/fetchHealthCareProductList",
      payload
    );
    this.isLoading = false;
  },
};
</script>

<style scoped></style>
